import StepGDPRController from "./stepGDPRController";
import "./stepGDPR.scss";

const StepGDPRComponent = {
    template: require("./stepGDPRView.html"),
    controller: StepGDPRController,
};

export default StepGDPRComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepGDPR/stepGDPRComponent.js